// src/api/savedSearch.js
import axios from 'axios';
import { baseApi } from './apiConfig';

export const getSaveSearchDetails = async (page = 0) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/getSaveSearchDetails/${page}?_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching saved search details:', error);
        throw error;
    }
};

//Edit save search name
export const updateSaveSearchName = async (searchData) => {
    try {

        const response = await baseApi.post(
            '/portal/saveSearch/editSaveSearchName',
            searchData
        );

        return response.data;
    } catch (error) {
        console.error('Error updating saved search name:', error);
        throw error;
    }
};



export const getUserSavedSearch = async (emailId, pageNumber, pageSize) => {
    try {

        const payload = {
            emailId: emailId || '',
            pageNumber: pageNumber || 0,
            pageSize: pageSize || '3',
        }

        const response = await baseApi.post('/portal/drawer/getUserSavedSearch', payload);
        return response.data;
    } catch (error) {
        console.error('Error in getUserSavedSearch:', error);
        throw error;
    }
};


export const DeleteUserSavedSearch = async (searchId) => {
    const config = {
        headers: {
          // Use text/plain for string data
          'Content-Type': 'text/plain'
        }
      };
    try {
        const response = await baseApi.post(`/portal/deleteSaveSearch/${searchId}`, searchId,config);
        return response.data;
    } catch (error) {
        console.error('Error in DeleteUserSavedSearch:', error);
        throw error;
    }
}
export const getSavedSearchAndPropertyCount = async (emailId) => {
    try {
        const response = await baseApi.post('/portal/getSavedSearchAndPropertyCount',emailId);
        return response.data;
    } catch (error) {
        console.error('Error fetching saved search and property count:', error);
        throw error;
    }
};

let cancelToken;
export const getIsSaveSearch = async ({polygonId, polygonType, params}) => {
    try {
        if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
        }
        cancelToken = axios.CancelToken.source();
        const response = await baseApi.post(`/portal/isSearchSaved/${polygonType}/${polygonId}`, params, { cancelToken: cancelToken.token });
        return response.data;
    } catch (error) {
        console.error('Error fetching isSaveSearch:', error);
        throw error;
    }
};
export const onDeleteSaveSearch = async ({searchId, params}) => {
    try {
        const response = await baseApi.post(`/portal/deleteSaveSearch/${searchId}`, params);
        return response.data;
    } catch (error) {
        console.error('Error fetching isSaveSearch:', error);
        throw error;
    }
};
export const getIsValidSearchName = async ({searchName}) => {
    try {
        const response = await baseApi.post(`/portal/isValidSaveSearchName`, {searchName});
        return response.data;
    } catch (error) {
        console.error('Error fetching isSaveSearch:', error);
        throw error;
    }
};
export const onSaveSearch = async ({polygonId, polygonType, params}) => {
    try {
        const response = await baseApi.post(`/portal/saveSearch/${polygonType}/${polygonId}`, params);
        return response.data;
    } catch (error) {
        console.error('Error fetching isSaveSearch:', error);
        throw error;
    }
};
export const getSearchUrl = async ({id, type}) => {
    try {
        const response = await baseApi.get(`/portal/getSearchUrl?id=${id}&type=${type}`);
        if (response?.data?.type === 'VALID') {
            return response.data;
        } else {
            throw response;
        }
    } catch (error) {
        console.error('Error fetching getSearchUrl:', error);
        throw error;
    }
};

export const saveRecentSearch = async ({searchBy, url, searchURI}) => {
    try {
        const formData = new FormData();
        formData.append("searchBy", searchBy);
        formData.append("baseSearchUrl", url);
        formData.append("searchURI", searchURI);
        const response = await baseApi.post("/portal/saveRecentSearch", formData);
        const { status, data } = response;
        if (status === 200) {
            return data;
        } else {
            throw response;
        }
    } catch (error) {
        console.error("Error in updateRecentSearch", error);
    }
};

export const deleteRecentSearch = async (id) => {
    try {
        const response = await baseApi.post(`/portal/delete-recent-search?id=${encodeURIComponent(id)}`);
        return response.data;
    } catch (error) {
        console.error("Error in deleteRecentSearch", error);
        throw error;
    }
};